var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstitution(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_535_5896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1247 22.2234H8.50586V43.3808H16.1247V22.2234Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.959 22.2234H22.3401V43.3808H29.959V22.2234Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7824 22.2234H36.1636V43.3808H43.7824V22.2234Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0854 5.10015C23.946 4.38902 25.0276 4 26.144 4C27.2604 4 28.3419 4.38902 29.2025 5.10015L36.1197 10.8444L46.1065 19.1211H6.19238L16.1682 10.8444L23.0854 5.10015Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19248 22.7496H46.1066C46.688 22.7496 47.2457 22.5186 47.6569 22.1074C48.0681 21.6963 48.299 21.1386 48.299 20.5571C48.299 19.9756 48.0681 19.418 47.6569 19.0068C47.2457 18.5956 46.688 18.3646 46.1066 18.3646H6.19248C5.611 18.3646 5.05335 18.5956 4.64218 19.0068C4.23101 19.418 4 19.9756 4 20.5571C4 21.1386 4.23101 21.6963 4.64218 22.1074C5.05335 22.5186 5.611 22.7496 6.19248 22.7496Z",
    fill: "#69E269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1066 42.8544H6.19248C5.611 42.8544 5.05335 43.0854 4.64218 43.4965C4.23101 43.9077 4 44.4654 4 45.0468C4 45.6283 4.23101 46.186 4.64218 46.5972C5.05335 47.0083 5.611 47.2393 6.19248 47.2393H46.1066C46.688 47.2393 47.2457 47.0083 47.6569 46.5972C48.0681 46.186 48.299 45.6283 48.299 45.0468C48.299 44.4654 48.0681 43.9077 47.6569 43.4965C47.2457 43.0854 46.688 42.8544 46.1066 42.8544Z",
    fill: "#69E269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1443 14.2979C27.8638 14.2979 29.2576 12.904 29.2576 11.1846C29.2576 9.46517 27.8638 8.07129 26.1443 8.07129C24.4249 8.07129 23.031 9.46517 23.031 11.1846C23.031 12.904 24.4249 14.2979 26.1443 14.2979Z",
    fill: "#69E269"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_535_5896",
    x: 0,
    y: 0,
    width: 60.2991,
    height: 59.2394,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.176471 0 0 0 0 0.227451 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_535_5896"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_535_5896",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitution);
export default __webpack_public_path__ + "static/media/institution.88e63ad1a7432e1679c1ad26f15ba466.svg";
export { ForwardRef as ReactComponent };